<template>
  <figure class="mx-auto flex w-full max-w-3xl justify-between gap-3 md:gap-4">
    <template v-if="step === 1">
      <div class="h-[6px] w-full rounded-full bg-green-25">
        <div class="h-full w-1/2 rounded-full bg-green"></div>
      </div>
      <div class="h-[6px] w-full rounded-full bg-green-25"></div>
      <div class="h-[6px] w-full rounded-full bg-green-25"></div>
      <div class="h-[6px] w-full rounded-full bg-green-25"></div>
      <div class="h-[6px] w-full rounded-full bg-green-25"></div>
      <div class="h-[6px] w-full rounded-full bg-green-25"></div>
      <div class="h-[6px] w-full rounded-full bg-green-25"></div>
    </template>
    <template v-if="step === 2">
      <div class="h-[6px] w-full rounded-full bg-green-25">
        <div class="h-full w-full rounded-full bg-green"></div>
      </div>
      <div class="h-[6px] w-full rounded-full bg-green-25"></div>
      <div class="h-[6px] w-full rounded-full bg-green-25"></div>
      <div class="h-[6px] w-full rounded-full bg-green-25"></div>
      <div class="h-[6px] w-full rounded-full bg-green-25"></div>
      <div class="h-[6px] w-full rounded-full bg-green-25"></div>
      <div class="h-[6px] w-full rounded-full bg-green-25"></div>
    </template>
    <template v-if="step === 3">
      <div class="h-[6px] w-full rounded-full bg-green-25">
        <div class="h-full w-full rounded-full bg-green"></div>
      </div>
      <div class="h-[6px] w-full rounded-full bg-green-25">
        <div class="h-full w-full rounded-full bg-green"></div>
      </div>
      <div class="h-[6px] w-full rounded-full bg-green-25"></div>
      <div class="h-[6px] w-full rounded-full bg-green-25"></div>
      <div class="h-[6px] w-full rounded-full bg-green-25"></div>
      <div class="h-[6px] w-full rounded-full bg-green-25"></div>
      <div class="h-[6px] w-full rounded-full bg-green-25"></div>
    </template>
    <template v-if="step === 4">
      <div class="h-[6px] w-full rounded-full bg-green-25">
        <div class="h-full w-full rounded-full bg-green"></div>
      </div>
      <div class="h-[6px] w-full rounded-full bg-green-25">
        <div class="h-full w-full rounded-full bg-green"></div>
      </div>
      <div class="h-[6px] w-full rounded-full bg-green-25">
        <div class="h-full w-1/2 rounded-full bg-green"></div>
      </div>
      <div class="h-[6px] w-full rounded-full bg-green-25"></div>
      <div class="h-[6px] w-full rounded-full bg-green-25"></div>
      <div class="h-[6px] w-full rounded-full bg-green-25"></div>
      <div class="h-[6px] w-full rounded-full bg-green-25"></div>
    </template>
    <template v-if="step === 5">
      <div class="h-[6px] w-full rounded-full bg-green-25">
        <div class="h-full w-full rounded-full bg-green"></div>
      </div>
      <div class="h-[6px] w-full rounded-full bg-green-25">
        <div class="h-full w-full rounded-full bg-green"></div>
      </div>
      <div class="h-[6px] w-full rounded-full bg-green-25">
        <div class="h-full w-full rounded-full bg-green"></div>
      </div>
      <div class="h-[6px] w-full rounded-full bg-green-25"></div>
      <div class="h-[6px] w-full rounded-full bg-green-25"></div>
      <div class="h-[6px] w-full rounded-full bg-green-25"></div>
      <div class="h-[6px] w-full rounded-full bg-green-25"></div>
    </template>
    <template v-if="step === 6">
      <div class="h-[6px] w-full rounded-full bg-green-25">
        <div class="h-full w-full rounded-full bg-green"></div>
      </div>
      <div class="h-[6px] w-full rounded-full bg-green-25">
        <div class="h-full w-full rounded-full bg-green"></div>
      </div>
      <div class="h-[6px] w-full rounded-full bg-green-25">
        <div class="h-full w-full rounded-full bg-green"></div>
      </div>
      <div class="h-[6px] w-full rounded-full bg-green-25">
        <div class="h-full w-full rounded-full bg-green"></div>
      </div>
      <div class="h-[6px] w-full rounded-full bg-green-25"></div>
      <div class="h-[6px] w-full rounded-full bg-green-25"></div>
      <div class="h-[6px] w-full rounded-full bg-green-25"></div>
    </template>
    <template v-if="step === 7">
      <div class="h-[6px] w-full rounded-full bg-green-25">
        <div class="h-full w-full rounded-full bg-green"></div>
      </div>
      <div class="h-[6px] w-full rounded-full bg-green-25">
        <div class="h-full w-full rounded-full bg-green"></div>
      </div>
      <div class="h-[6px] w-full rounded-full bg-green-25">
        <div class="h-full w-full rounded-full bg-green"></div>
      </div>
      <div class="h-[6px] w-full rounded-full bg-green-25">
        <div class="h-full w-full rounded-full bg-green"></div>
      </div>
      <div class="h-[6px] w-full rounded-full bg-green-25">
        <div class="h-full w-1/2 rounded-full bg-green"></div>
      </div>
      <div class="h-[6px] w-full rounded-full bg-green-25"></div>
      <div class="h-[6px] w-full rounded-full bg-green-25"></div>
    </template>
    <template v-if="step === 8">
      <div class="h-[6px] w-full rounded-full bg-green-25">
        <div class="h-full w-full rounded-full bg-green"></div>
      </div>
      <div class="h-[6px] w-full rounded-full bg-green-25">
        <div class="h-full w-full rounded-full bg-green"></div>
      </div>
      <div class="h-[6px] w-full rounded-full bg-green-25">
        <div class="h-full w-full rounded-full bg-green"></div>
      </div>
      <div class="h-[6px] w-full rounded-full bg-green-25">
        <div class="h-full w-full rounded-full bg-green"></div>
      </div>
      <div class="h-[6px] w-full rounded-full bg-green-25">
        <div class="h-full w-full rounded-full bg-green"></div>
      </div>
      <div class="h-[6px] w-full rounded-full bg-green-25"></div>
      <div class="h-[6px] w-full rounded-full bg-green-25"></div>
    </template>
    <template v-if="step === 9">
      <div class="h-[6px] w-full rounded-full bg-green-25">
        <div class="h-full w-full rounded-full bg-green"></div>
      </div>
      <div class="h-[6px] w-full rounded-full bg-green-25">
        <div class="h-full w-full rounded-full bg-green"></div>
      </div>
      <div class="h-[6px] w-full rounded-full bg-green-25">
        <div class="h-full w-full rounded-full bg-green"></div>
      </div>
      <div class="h-[6px] w-full rounded-full bg-green-25">
        <div class="h-full w-full rounded-full bg-green"></div>
      </div>
      <div class="h-[6px] w-full rounded-full bg-green-25">
        <div class="h-full w-full rounded-full bg-green"></div>
      </div>
      <div class="h-[6px] w-full rounded-full bg-green-25">
        <div class="h-full w-full rounded-full bg-green"></div>
      </div>
      <div class="h-[6px] w-full rounded-full bg-green-25"></div>
    </template>
    <template v-if="step === 10">
      <div class="h-[6px] w-full rounded-full bg-green-25">
        <div class="h-full w-full rounded-full bg-green"></div>
      </div>
      <div class="h-[6px] w-full rounded-full bg-green-25">
        <div class="h-full w-full rounded-full bg-green"></div>
      </div>
      <div class="h-[6px] w-full rounded-full bg-green-25">
        <div class="h-full w-full rounded-full bg-green"></div>
      </div>
      <div class="h-[6px] w-full rounded-full bg-green-25">
        <div class="h-full w-full rounded-full bg-green"></div>
      </div>
      <div class="h-[6px] w-full rounded-full bg-green-25">
        <div class="h-full w-full rounded-full bg-green"></div>
      </div>
      <div class="h-[6px] w-full rounded-full bg-green-25">
        <div class="h-full w-full rounded-full bg-green"></div>
      </div>
      <div class="h-[6px] w-full rounded-full bg-green-25">
        <div class="h-full w-full rounded-full bg-green"></div>
      </div>
    </template>
  </figure>
</template>

<script>
export default {
  props: {
    step: {
      type: Number,
      default: 0,
    },
  },
};
</script>
